import {
  Anchor,
  Button,
  Card,
  Center,
  Divider,
  Stack,
  ThemeIcon,
  Title,
  TypographyStylesProvider,
  Image,
} from "@mantine/core";

import React from "react";
import { IconFileInvoice } from "@tabler/icons-react";
import DocsButton from "../articlesHelpers/DocsButton";
import SimpleImage from "../articlesHelpers/SimpleImage";

export const SEND_TO_LIGHTNING_INVOICE_CONTENT = (
  <TypographyStylesProvider>
    <p>
      Another option for sending lightning payments is to send to a lightning
      invoice.
    </p>
    <DocsButton
      ariaLabel="send lightning invoice"
      text="Pay to Invoice"
      leftSection={<IconFileInvoice />}
    />
    <p>
      When you select this option, you'll be presented with a blank form where
      you can paste an invoice. You'll also see a "Scan QR Code" button.{" "}
    </p>

    <SimpleImage h={200} src="docs_images/pay-to-lightning-invoice.png" />

    <p>Here you can paste in an invoice string, which looks like...</p>

    <pre>
      lnbc1pnnwku7pp59s488nhpfn7gg09c6zxmpzaade8wcrnkqrj9seat0zagf4hjarysdqqcqzzsxqyjwn7rzjqg5pml4hdnm85ffw2rjhvhevdmxa7248ymueh682argnz6azny8hnapyqqqqqqqqqvqqqqlgqqqq86qq2qsp5hl32uratewxun87qhm38aghy8p5f6eq7k66u87cz9qwlea6sprkq9p4gqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqpqysgqfkf87w0qprkn6tvkwywd3d7k3z7psm7egsela6u7jwxp7r9vhg2qjhdpxf7cjzdafjxmd3p3h82t5tny8qun9u74cz9qlmqecuel2fqq934d2x
    </pre>

    <p>
      Rizful Node validates the invoice for you, so if you enter something that
      isn't a valid invoice, you'll see an error message like this:
    </p>

    <SimpleImage h={200} src="docs_images/invalid-invoice.png" />
    <p>
      Once you provide a valid invoice, you'll then be presented with a final
      screen, where you can enter your 2FA code to initiate the payment.
    </p>

    <SimpleImage
      h={400}
      src="docs_images/pay-to-lightning-invoice-after-validation.png"
    />
  </TypographyStylesProvider>
);
